<template>
  <div>
    <div
      v-if="show && show.coverImageUrl"
      class="header--content"
      :style="{
        backgroundImage:
          'linear-gradient(0deg, rgba(40,67,103,1) 0%, rgba(255,255,255,0.1) 100%), url(' +
          show.coverImageUrl +
          ')'
      }"
    ></div>
    <div v-else class="header--content empty-back"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["show"])
};
</script>

<style scoped>
.header--content {
  background-size: cover;

  /* margin-top: 63px; */
  height: 80vh;
  width: 100%;
  overflow: hidden;
}

.empty-back {
  background: linear-gradient(
    0deg,
    rgba(40, 67, 103, 1) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
}
@media (max-width: 600px) {
  .header--content {
    visibility: hidden;
    height: 0px;
  }
}
</style>
